<div
  class="wrapper account-wrapper"
  [ngClass]="isExpand ? 'ces-menu-collapse' : 'ces-apps-menu-collapsed'"
>
  <div class="header-wrapper">
    <ces-header
      [appHeaderLogo]="headerLogo"
      customHeaderClass="custom-top-header-class"
      logoRedirectUrl="https://ces-ltd.com/"
    >
      <header-end>
        <div class="header-right">
          <div
            header-end-item
            class="header-right-item"
          >
            <ces-button
              *ngIf="showAdminBtn"
              class="admin-panel-btn"
              label="Admin Panel"
              size="medium"
              status="primary"
              (onClick)="redirectAdmin()"
            ></ces-button>
            <div
              *ngIf="showAdminBtn"
              class="goto-app-selection theme-switcher-btn admin-panel-icon-btn"
              title="Go To Admin"
              (click)="redirectAdmin()"
            >
              <i class="icon icon-user-setting"></i>
            </div>
          </div>

          <div
            header-end-item
            class="header-right-item"
            [ngClass]="{ 'hide-goto-app': !showAppsBtn }"
          >
            <div
              *ngIf="showAppsBtn"
              class="goto-app-selection theme-switcher-btn"
              title="Go To applications"
              (click)="redirectApp()"
            >
              <i class="icon icon-app-drawer"></i>
            </div>
          </div>

          <div
            header-end-item
            class="header-right-item color-theme-switcher"
          >
            <div class="ces-theme-switcher theme-switcher">
              <button
                [attr.title]="'Switch to ' + (switchThemeToggle ? 'light theme' : 'dark theme')"
                type="button"
                class="theme-switcher-btn"
                (click)="switchTheme()"
                [class.dark-theme-switched]="switchThemeToggle"
              >
                <i
                  class="icon"
                  [ngClass]="switchThemeToggle ? 'icon-sun' : 'icon-moon'"
                ></i>
              </button>
            </div>
          </div>
          <div
            header-end-item
            class="header-right-item"
          >
            <profile-menu
              [menuItems]="profileUserMenu"
              [userName]="userName"
              [avatarName]="profileUrl ? '' : avatarName"
              [profileImageUrl]="profileUrl"
            ></profile-menu>
          </div>
        </div>
      </header-end>
    </ces-header>
  </div>
  <div class="height-100 ces-apps-layout main-content">
    <div class="app-container">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- <ces-footer class="custom-app-footer"></ces-footer> -->
</div>
